import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Accommodation from "@/pages/Accommodation";
import Services from "@/pages/Services";
import Referrals from "@/pages/Referrals";
import Landlords from "@/pages/Landlords";
import Volunteer from "@/pages/Volunteer";
import Business from "@/pages/Business";
import TenantHub from "@/pages/TenantHub";
import News from "@/pages/News";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import { Privacy, Accessibility } from "@/pages/Legal";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/accommodation" element={<Accommodation />} />
          <Route path="/support-services" element={<Services />} />
          <Route path="/referrals" element={<Referrals />} />
          <Route path="/landlords" element={<Landlords />} />
          <Route path="/volunteer" element={<Volunteer />} />
          <Route path="/business" element={<Business />} />
          <Route path="/tenant-hub" element={<TenantHub />} />
          <Route path="/news" element={<News />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/accessibility" element={<Accessibility />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
